// eslint-disable-next-line import/no-cycle
import { getUnreadChatsV2 } from './getUnreadChatsV2';
import { getLastTimeStamp } from '../../reducers/chatList/helpers';
import { TThunkAction } from '../../types/redux/thunk';

export const getUnreadListNextPage = (): TThunkAction<void> => (dispatch, getState) => {
  const state = getState();
  const { chatList } = state;

  const timestamp = chatList.isFirstLoad
    ? undefined
    : chatList.chats.length
      ? getLastTimeStamp(chatList.chats)
      : state.chatList.timestamp;

  dispatch(getUnreadChatsV2({ timestamp }));
};
